/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ChakraProvider, theme } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { BizlinkSdk } from './core/sdk/BizlinkSdk'
import Tracking from './core/utils/Tracking'
import { ExtensionChannelFactory } from './core/context/ExtensionChannelFactory'
import { LineExtensionChannel } from './core/context/LineExtensionChannel'
import infoStore from './core/stores/Viriyah/infoStore'
import tokenStore from './core/stores/Viriyah/tokenStore'
import otpStore from './core/stores/Viriyah/otpStore'
import userStore from './core/stores/Viriyah/userStore'
import Header from './components/generics/Header'
import TermsNCondition from './pages/TermsNCondition/TermsNCondition'
import OtpRequest from './pages/OtpRequest/OtpRequest'
import LoginSuccess from './pages/LoginSuccess/LoginSuccess'
import PDPA from './pages/PDPA/PDPA'
import MyPolicy from './pages/MyPolicy/MyPolicy'
import UserInformationValidate from './pages/UserInformationValidate/UserInformationValidate'
import MakeClaimInformation from './pages/MakeClaim/MakeClaim'
import MakeClaimSuccess from './pages/MakeClaimSuccess/MakeClaimSuccess'
import RegisterForm from './pages/Register/RegisterForm'
import { mappingMessageCode } from './core/utils/Utils'
import AppointmentClaimInformation from './pages/AppointmentClaimInformation/AppointmentClaimInformation'
import { LoadingSpinerDataComponent } from './components/generics/LoadingData'
import './styles/main.scss'
import 'bootstrap/dist/css/bootstrap.css'
import 'react-datepicker/dist/react-datepicker.css'

export type Language = 'TH' | 'EN'

// need to send page tracking to zanroo by adding use effect
const sleep = async (ms: number | undefined) => await new Promise(resolve => setTimeout(resolve, ms))

const App = () => {
  const [form, setState] = useState({
    errorMessage: { status: false, message: '' }
  })
  const [firstTimeUse, setFirstTimeUse] = useState(false)
  const [LoadingStatus, setLoadingStatus] = useState(true)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  window.bizlink = BizlinkSdk.getInstance()
  window.tracking = Tracking.getInstance()
  window.bizlink.translate = t

  useEffect(() => {
    const getProfile = async () => {
      try {
        const profile = await window.social.getUserProfile()
        const userId = profile.userId
        const displayName = profile.displayName
        document.cookie = `user_id=${userId}`
        document.cookie = `displayName=${displayName}`
        userStore.setUserInfo(userId, displayName)
        console.log('🚀 ~ file: App.tsx ~ line 105 ~ getProfile ~ userStore', userStore)
      } catch (e) {
        console.log('getProfile', e)
      }
    }

    const initialSocial = async () => {
      const channel = await ExtensionChannelFactory.initExtension()
      window.social = channel
      if (channel instanceof LineExtensionChannel) {
        if (!channel.checkIsClient()) {
          if (!channel.checkLogin()) {
            if (window.bizlink.navigate.location.pathname !== '/expire') {
              channel.Login()
            }
          }
        }
        await getProfile()
        setLoadingStatus(false)
      } else {
        window.social = channel
        setLoadingStatus(false)
      }
    }

    const initialExtention = async () => {
      try {
        await sleep(2500)
        console.log('getMember')
        const pathName = 'getMember'
        const payload = {
          userId: userStore.userId
        }
        window.bizlink
          .trigger('POST', {
            payload,
            pathName
          })
          .then((response: any) => {
            console.log('getMember response.success : ', response.success)

            if (response.success) {
              console.log('response.userInfo.userStatus : ', response.userInfo.userStatus)

              if (!response.userInfo.userStatus) {
                navigate('/terms-and-cond', { replace: true })
                setLoadingStatus(false)
              } else if (response.userInfo.userStatus === 'Active') {
                navigate('/login-success', { replace: true })
                setLoadingStatus(false)
              } else if (response.userInfo.userStatus === 'Inactive') {
                getUserData()
              }
            } else {
              console.log('getMember not success!')
              setLoadingStatus(false)
            }
          })
          .catch(err => {
            console.log(err)
            let message = ''

            if (err.message === 'Network Error') {
              const messageError = mappingMessageCode(
                t('viriyah.validate-message.service-error'),
                'API: getMember, ',
                err.code
              )
              message = `${t(
                'viriyah.validate-message.login-form.logo'
              )} <div style='width: 90%; padding-left: 2%;'><p> ${messageError} </p></div></div>`
            } else {
              const messageError = mappingMessageCode(
                t('viriyah.validate-message.service-error'),
                10,
                err.response?.code ?? err.response.status
              )
              message = `${t(
                'viriyah.validate-message.login-form.logo'
              )} <div style='width: 90%; padding-left: 2%;'><p> ${messageError} </p></div></div>`
            }
            setState(form => ({
              ...form,
              errorMessage: { status: true, message }
            }))
            setLoadingStatus(false)
          })
      } catch (e) {
        if (e instanceof Error) {
          // ✅ TypeScript knows e is Error
          console.log('ERROR : ', e)
          const messageError = mappingMessageCode(
            t('viriyah.validate-message.service-error'),
            'API: getMember, ',
            e.message
          )
          const message = `${t(
            'viriyah.validate-message.login-form.logo'
          )} <div style='width: 90%; padding-left: 2%;'><p> ${messageError} </p></div></div>`
          setState(form => ({
            ...form,
            errorMessage: { status: true, message }
          }))
          setLoadingStatus(false)
        } else {
          console.log('Unexpected error', e)
          setLoadingStatus(false)
        }
      }
    }

    const initialData = async () => {
      if (!firstTimeUse) {
        window.bizlink.navigate = navigate
        await initialSocial()
        if (location.pathname === '/register') {
          console.log('location.pathname : ' + location.pathname)
          await initialExtention()
        }
        setFirstTimeUse(true)
      }
    }

    initialData();
  }, [])

  const getUserData = () => {
    const pathName = 'getMemberFromLineId'
    const payload = {
      userId: userStore.userId
    }

    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('getUserData response : ', response)
        if (response.status === 'success') {
          const firstName: string = response.userInfo.firstName
          const lastName: string = response.userInfo.lastName
          const idCardNumber: string = response.userInfo.idCardNumber
          const mobileNo: string = response.userInfo.mobileNo

          infoStore.setMyPolicy(firstName, lastName, idCardNumber, mobileNo)
          chkMyPolicy()
        } else {
          navigate('/terms-and-cond', { replace: true })
          setLoadingStatus(false)
          console.log('getUserData not success!!!')
        }
      })
      .catch(err => {
        const message = `${t(
          'viriyah.validate-message.login-form.logo'
        )} <div style='width: 90%; padding-left: 2%;'><p> ${t(
          'viriyah.validate-message.login-form.logo'
        )} <div style='width: 90%; padding-left: 2%;'><p> ${t(
          'viriyah.validate-message.service-error'
        )} (API: getMemberFromLineId, ${err.message}) </p></div></div>
        `
        setState(form => ({
          ...form,
          errorMessage: { status: true, message }
        }))
        console.log('error', pathName, 'with', err.message)
        setLoadingStatus(false)
      })
  }

  const chkMyPolicy = () => {
    const pathName = 'myPolicy'
    const payload = {
      thaiid: infoStore.idCardNumber,
      thfirstname: infoStore.firstName,
      thlastname: infoStore.lastName,
      mobilelast4digit: mobilelast4digit(infoStore.mobileNumber),
      userId: userStore.userId
    }

    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('myPolicy response : ', response)
        if (!response.error) {
          navigate('/otp-request', { replace: true })
          generateOTP()
        } else {
          console.log('myPolicy not success!!!')
        }
      })
      .catch(err => {
        console.log('error', pathName, 'with', err.message)
        navigate('/login-form', { replace: true })
        setLoadingStatus(false)
      })
  }

  const generateOTP = () => {
    const pathName = 'generateOTP'
    const payload = {
      mobileNumber: infoStore.mobileNumber,
      userId: userStore.userId
    }
    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('response.requestId : ', response.requestId)

        if (response.message === 'successfully') {
          const referenceCode: string = response.requestId || ''
          tokenStore.setReOtp(referenceCode)
          console.log('tokenStore.referenceCode : ' + tokenStore.referenceCode)
          otpStore.setOtp('')
          setLoadingStatus(false)
        } else {
          console.log('generateOTP not success!!!')
          otpStore.setOtp('')
          setLoadingStatus(false)
        }
      })
      .catch(err => {
        const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 50, err.response?.status)
        const message = `${t(
          'viriyah.validate-message.login-form.logo'
        )} <div style='width: 90%; padding-left: 2%;'><p> ${errorMessage} </p></div></div>`
        setState(form => ({
          ...form,
          errorMessage: { status: true, message }
        }))
        console.log('error', pathName, 'with', err.message)
        setLoadingStatus(false)
      })
  }

  const mobilelast4digit = (e: string) => {
    return e.substr(-4)
  }

  if (LoadingStatus) {
    return <LoadingSpinerDataComponent />
  }

  return (
    <ChakraProvider theme={theme}>
      <Header />
      <div id="content">
        <div dangerouslySetInnerHTML={{ __html: form.errorMessage.status ? form.errorMessage.message : '' }} />

        <Routes>
          <Route path="/login-form" element={<RegisterForm />} />
          <Route path="/otp-request" element={<OtpRequest />} />
          <Route path="/terms-and-cond" element={<TermsNCondition />} />
          <Route path="/login-success" element={<LoginSuccess />} />
          <Route path="/PDPA-page" element={<PDPA />} />
          <Route path="/my-policy" element={<MyPolicy />} />
          <Route path="/user-information-validate" element={<UserInformationValidate />} />
          <Route path="/make-claim-information" element={<MakeClaimInformation />} />
          <Route path="/make-claim-success" element={<MakeClaimSuccess />} />
          <Route path="/appointment-claim-information" element={<AppointmentClaimInformation />} />
        </Routes>
      </div>
    </ChakraProvider>
  )
}
export default App
